import { Routes } from '@angular/router';
import { AnonymousRouteGuard } from "@security/route-guards/anonymous.route-guard";
import { UnauthorisedComponent } from './app-layout/error-pages/unauthorised/unauthorised.component';
import { authenticationRoutes } from './app-layout/authentication/authentication.routes';
import { AuthenticatedRouteGuard } from '@security/route-guards/authenticated.route-guard';
import { environment } from '@env/environment';
import { defaultPostLoginRootGuard } from '@auth/default-post-login-redirect.guard';
import { DefaultPostLoginRedirectComponent } from '@auth/default-post-login-redirect.component';


// Create conditional routes based on active areas
const conditionalRoutes: Routes = [];

// Only add module routes if the corresponding area is active
if (environment.activeAreas.includes('Messenger')) {
  conditionalRoutes.push({
    path: '',
    canActivate: [AuthenticatedRouteGuard],
    loadChildren: () => import('./submodules/module-loaders/market-messenger-module-loader').then(m => m.loadMarketMessengerModule())
  });
}

if (environment.activeAreas.includes('Message Vault')) {
  conditionalRoutes.push({
    path: '',
    canActivate: [AuthenticatedRouteGuard],
    loadChildren: () => import('./submodules/module-loaders/message-vault-module-loader').then(m => m.loadMessageVaultModule())
  });
}

if (environment.activeAreas.includes('Settings')) {
  conditionalRoutes.push({
    path: '',
    canActivate: [AuthenticatedRouteGuard],
    loadChildren: () => import('./submodules/module-loaders/settings-module-loader').then(m => m.loadSettingsMessengerModule())
  });
}

if (environment.activeAreas.includes('Reports')) {
  conditionalRoutes.push({
    path: '',
    canActivate: [AuthenticatedRouteGuard],
    loadChildren: () => import('./submodules/module-loaders/reporting-module-loader').then(m => m.loadReportingModule())
  });
}

export const routes: Routes = [ 
  {
    path: '',
    canActivate: [defaultPostLoginRootGuard],
    children: [        
      {
        path: '',
        canActivate: [AuthenticatedRouteGuard],
        component: DefaultPostLoginRedirectComponent,
      },
      {
        path: 'auth',
        canActivate: [AnonymousRouteGuard],
        children: [
          ...authenticationRoutes
        ]
      },
      {
        path: 'errors',
        canActivate: [AnonymousRouteGuard],
        children: [
          {
            path: '403',
            component: UnauthorisedComponent,
            outlet: 'top'
          }
        ]
      }
    ]
  },
  // Add conditional routes
  ...conditionalRoutes,
  { path: '**', redirectTo: '' }
];
